import request from "../request";

/**
 * 分页查询招聘信息（筛选与分页由后端处理）
 * 前端约定 query：pageIndex、pageSize，及业务筛选字段（空值不传）
 * 若后端分页参数名不同（如 current、pageIndex），请在调用处改 buildListQueryParams
 */
export function getJobList(params) {
  return request({
    url: `interviewer/business-performance`,
    method: "get",
    params,
  });
}
// 修改业务画像
export function updateJob(data) {
  return request({
    url: `interviewer/business-performance`,
    method: "put",
    data,
  });
}

// 删除招聘信息
export function delJob(params) {
  return request({
    url: `interviewer/business-performance`,
    method: "delete",
    params,
  });
}

/** 面试登记表详情（与 admin_system 原接口一致，若网关前缀不同请改 url） */
export function getInterviewInfo(params) {
  return request({
    url: "interviewer/interview-information/getDetailById",
    method: "get",
    params,
  });
}
